/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price change predictions use a separate regression model trained on historical price movement patterns from the 2023 and 2024 seasons.`)
};

const es_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las predicciones de cambio de precio usan un modelo de regresión separado entrenado con patrones históricos de movimiento de precios de las temporadas 2023 y 2024.`)
};

const de_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisänderungsprognosen verwenden ein separates Regressionsmodell, trainiert auf historischen Preisbewegungsmustern der Saisons 2023 und 2024.`)
};

const nl_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijswijzigingsvoorspellingen gebruiken een apart regressiemodel dat is getraind op historische prijsbewegingspatronen van de seizoenen 2023 en 2024.`)
};

const fr_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les prédictions de changement de prix utilisent un modèle de régression séparé entraîné sur les tendances historiques de mouvements de prix des saisons 2023 et 2024.`)
};

const it_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le previsioni di variazione prezzo usano un modello di regressione separato addestrato sui pattern storici di movimento dei prezzi delle stagioni 2023 e 2024.`)
};

const pt_br2_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As previsões de mudança de preço usam um modelo de regressão separado treinado em padrões históricos de movimento de preços das temporadas 2023 e 2024.`)
};

const pt_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As previsões de alteração de preço usam um modelo de regressão separado treinado com padrões históricos de movimento de preços das épocas de 2023 e 2024.`)
};

const ja_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格変動予測は2023年と2024年シーズンの過去の価格変動パターンでトレーニングされた別の回帰モデルを使用。`)
};

const zh_about_optimizer_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格变动预测使用基于2023和2024赛季历史价格变动模式训练的独立回归模型。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_optimizer_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_optimizer_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_optimizer_p2", locale)
	if (locale === "en") return en_about_optimizer_p2(inputs)
	if (locale === "es") return es_about_optimizer_p2(inputs)
	if (locale === "de") return de_about_optimizer_p2(inputs)
	if (locale === "nl") return nl_about_optimizer_p2(inputs)
	if (locale === "fr") return fr_about_optimizer_p2(inputs)
	if (locale === "it") return it_about_optimizer_p2(inputs)
	if (locale === "pt-BR") return pt_br2_about_optimizer_p2(inputs)
	if (locale === "pt") return pt_about_optimizer_p2(inputs)
	if (locale === "ja") return ja_about_optimizer_p2(inputs)
	return zh_about_optimizer_p2(inputs)
};